// components/EditCellModal.tsx

import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import MDButton from "components/MDButton";

interface EditCellModalProps {
  open: boolean;
  onClose: () => void;
  onSave: (value: string, sendEmail: boolean) => void;
  value: string;
  title: string;
  multiline?: boolean;
  showSendEmailCheckbox?: boolean; 
}

const EditCellModal: React.FC<EditCellModalProps> = ({
  open,
  onClose,
  onSave,
  value,
  title,
  multiline = true,
  showSendEmailCheckbox = false, 
}) => {
  const [inputValue, setInputValue] = React.useState(value);
  const [sendEmail, setSendEmail] = React.useState(true); 

  React.useEffect(() => {
    setInputValue(value);
  }, [value]);

  React.useEffect(() => {
    if(open){
      setSendEmail(true);
    } else{
      setSendEmail(false);
    }
  }, [open]);

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          margin="dense"
          label={title}
          type="text"
          fullWidth
          multiline={multiline}
          minRows={multiline ? 3 : 1}
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
        />

        {showSendEmailCheckbox && (
          <FormControlLabel
            control={
              <Checkbox
                checked={sendEmail}
                onChange={(e) => setSendEmail(e.target.checked)}
              />
            }
            label="Send Email"
          />
        )}
      </DialogContent>

      <DialogActions>
        <MDButton onClick={onClose} color="secondary" variant="outlined">
          Cancel
        </MDButton>

        <MDButton
          onClick={() => onSave(inputValue, sendEmail)}
          color="primary"
          variant="contained"
        >
          Save
        </MDButton>
      </DialogActions>
    </Dialog>
  );
};

export default EditCellModal;
